var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.875H1.75C1.51801 0.875232 1.29558 0.967493 1.13154 1.13154C0.967493 1.29558 0.875232 1.51801 0.875 1.75V12.25C0.875232 12.482 0.967493 12.7044 1.13154 12.8685C1.29558 13.0325 1.51801 13.1248 1.75 13.125H12.25C12.482 13.1247 12.7043 13.0324 12.8683 12.8683C13.0324 12.7043 13.1247 12.482 13.125 12.25V1.75C13.1248 1.51801 13.0325 1.29558 12.8685 1.13154C12.7044 0.967493 12.482 0.875232 12.25 0.875ZM12.25 4.8125H6.125V1.75H12.25V4.8125ZM5.25 1.75V4.8125H1.75V1.75H5.25ZM1.75 12.25V5.6875H12.25L12.2509 12.25H1.75Z",
    fill: "current",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.825H12.25L1.75 0.825L1.74995 0.825C1.50471 0.825245 1.26959 0.922773 1.09618 1.09618C0.922773 1.26959 0.825245 1.50471 0.825 1.74995V1.75L0.825 12.25L0.825 12.25C0.825245 12.4953 0.922773 12.7304 1.09618 12.9038C1.26959 13.0772 1.50471 13.1748 1.74995 13.175H1.75H12.25H12.2501C12.4953 13.1746 12.7303 13.0771 12.9037 12.9037C13.0771 12.7303 13.1746 12.4953 13.175 12.2501V12.25V1.75V1.74995C13.1748 1.50471 13.0772 1.26959 12.9038 1.09618C12.7304 0.922773 12.4953 0.825245 12.25 0.825ZM12.2 4.7625H6.175V1.8H12.2V4.7625ZM5.2 1.8V4.7625H1.8V1.8H5.2ZM1.8 12.2V5.7375H12.2L12.2009 12.2H1.8Z",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.ed079ff4a16064dcce6f9ebe85cc4023.svg";
export { ForwardRef as ReactComponent };